<template>
  <div v-if="isAuthenticated && user?.role" class="private-layout">
    <button
      v-if="isMobile"
      class="burger-menu"
      @click="toggleSidebar"
      :class="{ 'icon-collapsed': !sidebarVisible }"
    >
      &#9776;
    </button>

    <SidebarComponent
      :isAuthenticated="isAuthenticated"
      :isMobile="isMobile"
      :userRole="user.role.name"
      :sidebarVisible="sidebarVisible"
      @close-sidebar="sidebarVisible = false"
    />

    <div class="main-content">
      <UserBarComponent
        :userData="user"
        @logout="logout"
        :page-title="pageTitle"
      />

      <router-view v-slot="{ Component }">
        <div class="scrollable-content">
          <component :is="Component" @updateTitle="updatePageTitle" />
        </div>
      </router-view>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import UserBarComponent from "@/components/Layout/UserBarComponent.vue";
import SidebarComponent from "@/components/Layout/SidebarComponent.vue";

export default {
  name: "PrivateLayout",
  components: {
    UserBarComponent,
    SidebarComponent,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      sidebarVisible: false,
      pageTitleData: "Photobooth",
      routeTitleMap: {
        "/dashboard": "sidebar.dashboard",
        "/devices": "sidebar.devices",
        "/devices/list": "sidebar.devices",
        "/devices/closed-days": "sidebar.closed_days",
        "/devices/cleared-days": "sidebar.cleared_days",
        "/devices/inserted-coins": "sidebar.inserted_coins",
        "/devices/messages": "sidebar.device_messages",
        "/photos": "sidebar.photos",
        "/templates": "sidebar.templates",
        "/templates/list": "sidebar.templates",
        "/templates/groups": "sidebar.template_groups",
        "/reports": "sidebar.reports",
        "/reports/photo-stats": "sidebar.photo_stats",
        "/reports/revenue-analytics": "sidebar.revenue_analytics",
        "/users": "sidebar.users",
        "/users/profile/:id": "sidebar.profile",
        "/settings": "sidebar.settings",
      },
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.auth.isAuthenticated;
    },
    user() {
      return this.$store.state.auth.user;
    },
    pageTitle() {
      const currentPath = this.$route.path;

      if (this.routeTitleMap[currentPath]) {
        return this.$t(this.routeTitleMap[currentPath]);
      }

      if (currentPath.startsWith("/users/profile/")) {
        return this.$t("sidebar.profile");
      }

      return this.pageTitleData;
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    logout() {
      localStorage.removeItem("token");
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    updatePageTitle(title) {
      this.pageTitleData = title;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
